import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SsoService } from '@devinforius/i-sso';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard {
  private readonly router: Router = inject(Router);
  private readonly ssoService: SsoService = inject(SsoService);

  canActivate(): Promise<boolean> {
    const userIsConnected = this.ssoService.isConnected() || this.ssoService.hasValidAccessToken();

    return new Promise((resolve) => {
      if (userIsConnected) {
        resolve(true);
      } else {
        this.router.navigate(['public']);
        resolve(false);
      }
    });
  }
}
